import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useGloriaFood = () => {
  const location = useLocation();

  useEffect(() => {
    // Function to initialize the widget
    const initializeWidget = () => {
      if (window.glf) {
        try {
          // Force re-initialization with required parameters
          window.glf.initialize({
            restaurantId: 'c40c7189-7fc6-41af-835d-284faab90373',
            customerId: '26e28676-de7f-4b2e-ba47-0af18998b18d',
            language: 'en',
            region: 'us'
          });
        } catch (error) {
          console.error('Gloria Food initialization error:', error);
        }
      }
    };

    // Check if script exists
    let script = document.querySelector('script[src="https://www.fbgcdn.com/embedder/js/ewm2.js"]');
    
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://www.fbgcdn.com/embedder/js/ewm2.js';
      script.async = true;
      script.defer = true;
      
      // Initialize after script loads
      script.addEventListener('load', initializeWidget);
      
      // Add error handling
      script.addEventListener('error', (e) => {
        console.error('Gloria Food script failed to load:', e);
      });
      
      document.body.appendChild(script);
    } else {
      // If script exists, try to initialize
      setTimeout(initializeWidget, 100); // Small delay to ensure script is ready
    }

    return () => {
      if (script) {
        script.removeEventListener('load', initializeWidget);
      }
    };
  }, [location]);
}; 